import { Field, Input } from "@/components/ui/Input";

export function AdminPasswordConfirm({
  password,
  onPasswordChange,
  disabled,
}: {
  password: string;
  onPasswordChange: (value: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="rounded-2xl border border-border bg-canvas p-4">
      <Field label="Confirm with your password">
        <Input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          disabled={disabled}
          placeholder="Enter your login password"
        />
      </Field>
      <p className="mt-2 text-xs text-muted">
        Enter your Overwatch login password to confirm this change.
      </p>
    </div>
  );
}
